export default __webpack_public_path__ + "static/bariol_serif_bold-webfont-118a103426a9a315d5a3ee7dbf4d9082.eot";